// Shared UI/API vocabulary. Values intentionally match the Minimum Service Level workbook.
// Keep the existing permission identifier so saved matrix grants/denials carry over.
const ENTRY_PATH = '/case-management/register-interaction';
const REPORT_PATH = '/reporting/minimum-service-level';
const API_PATH = '/api/minimum-service-interactions';
const INQUIRY_TYPES = ['Email', 'Phone Call', 'Walk-in', 'Event'];
const SERVICES = ['How to Apply', 'Request Application', 'Resume Writing', 'Career Counselling', 'Assistance with Application', 'Use Computer', 'Job Board or Job Search', 'Access to Labour Market Information', 'Referral to other Funder or Agency', 'Other'];
const NATIONAL_REGION = 'CA';
const REGIONS = [
  [NATIONAL_REGION, 'National'],
  ['AB', 'Alberta'], ['BC', 'British Columbia'], ['MB', 'Manitoba'], ['NB', 'New Brunswick'],
  ['NL', 'Newfoundland and Labrador'], ['NT', 'Northwest Territories'], ['NS', 'Nova Scotia'],
  ['NU', 'Nunavut'], ['ON', 'Ontario'], ['PE', 'Prince Edward Island'], ['QC', 'Quebec'],
  ['SK', 'Saskatchewan'], ['YT', 'Yukon'], ['HO', 'NWAC Head Office'],
].map(([value, label]) => ({ value, label }));
const COLUMNS = [
  { id: 'interactionDate', label: 'Date of inquiry', width: 160 },
  { id: 'personName', label: 'Name', width: 190 },
  { id: 'phone', label: 'Phone', width: 190 },
  { id: 'email', label: 'Email', width: 240 },
  { id: 'inquiryType', label: 'Type of inquiry', width: 170 },
  { id: 'serviceProvided', label: 'Service provided', width: 280 },
  { id: 'notes', label: 'Notes', width: 320 },
  { id: 'regionName', label: 'Province / Territory', width: 210 },
  { id: 'recordedByName', label: 'Recorded by', width: 210 },
];
const MONTHS = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];
const MONTH_LABELS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const PERIODS = [
  { value: 'full', label: 'Full year' },
  ...[1, 2, 3, 4].flatMap((quarter, i) => [
    { value: `q${quarter}`, label: `Q${quarter} (${MONTH_LABELS[MONTHS[i * 3] - 1].slice(0, 3)}–${MONTH_LABELS[MONTHS[i * 3 + 2] - 1].slice(0, 3)})` },
    ...MONTHS.slice(i * 3, i * 3 + 3).map(month => ({ value: `m${String(month).padStart(2, '0')}`, label: MONTH_LABELS[month - 1] })),
  ]),
];
function fiscalYear(date = new Date()) { return date.getFullYear() - (date.getMonth() < 3 ? 1 : 0); }
function localDate(date = new Date()) { return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`; }
function regionLabel(code) { return REGIONS.find(region => region.value === code)?.label || code; }
function periodRange(year, period) {
  const fy = Number(year);
  if (!Number.isInteger(fy) || fy < 2000 || fy > 9997 || !PERIODS.some(item => item.value === period)) throw new Error('Choose a valid reporting period.');
  let startMonth = 4; let span = 12;
  if (period.startsWith('q')) { startMonth = MONTHS[(Number(period.slice(1)) - 1) * 3]; span = 3; }
  if (period.startsWith('m')) { startMonth = Number(period.slice(1)); span = 1; }
  const yearOfMonth = fy + (startMonth < 4 ? 1 : 0);
  const start = `${yearOfMonth}-${String(startMonth).padStart(2, '0')}-01`;
  const endDate = new Date(Date.UTC(yearOfMonth, startMonth - 1 + span, 1));
  return { start, endExclusive: endDate.toISOString().slice(0, 10) };
}
module.exports = { ENTRY_PATH, REPORT_PATH, API_PATH, INQUIRY_TYPES, SERVICES, NATIONAL_REGION, REGIONS, COLUMNS, PERIODS, MONTH_LABELS, MONTHS, fiscalYear, localDate, regionLabel, periodRange };
